import Title from "@/components/common/Typography/Title"
import { useAppSelector } from "@/lib/redux/hooks"

import { Row } from "antd"
import SearchingFlightItem from "./SearchingFlightItem"
import { FC, useContext } from "react"
import { SelectPlacementContext } from "."
import { useTranslation } from "react-i18next"
import { TypeAirport } from "@/lib/redux/features/flight/type"

const MAX_RECENT_SEARCHES = 3
type RecentFlight = {
  from: TypeAirport
  to: TypeAirport
  dateFrom: string
  dateTo: string
  cabinClass: unknown
  searchedAt?: number
}

type RecentlySearchProps = {
  onChoose: () => void
}

const RecentlySearch: FC<RecentlySearchProps> = ({ onChoose }) => {
  const currentlyFlights = useAppSelector(state => state.flight.currentlyFlights)
  const searchPopular = useAppSelector(state => state.flight.searchPopular)
  const { searching } = useContext(SelectPlacementContext)
  const { t } = useTranslation()

  if (Object.keys(currentlyFlights).length <= 0) {
    return <></>
  }

  if (searching && !searchPopular) {
    return <></>
  }

  const recentFlights = (Object.entries(currentlyFlights) as [string, RecentFlight][])
    .sort(([, flightA], [, flightB]) => {
      return (flightB.searchedAt || 0) - (flightA.searchedAt || 0)
    })
    .slice(0, MAX_RECENT_SEARCHES)

  return (
    <>
      <Row style={{ paddingLeft: '1.5rem' }}>
        <Title level={5} style={{ marginTop: '1rem' }}>
          {t("flight.recent_searches")}
        </Title>
      </Row>{recentFlights.map(([code, { from, to, dateFrom, dateTo, cabinClass }]) => {
        return (
          <SearchingFlightItem
            key={code}
            from={from} 
            to={to} 
            dateFrom={dateFrom}
            dateTo={dateTo}
            cabinClass={cabinClass}
            onChoose={onChoose}
          />
        )
      })}
    </>
  )
}


export default RecentlySearch